import { app, store } from '../index';
import { datapop } from '../actions/data-populate';
import { newfeedback } from '../actions/feedback';
import updateField from '../actions/update-field';
export const queryservice = (backendservice, param, value) => {
  console.log(param);
  return app
    .service(backendservice)
    .find({ query: { [param]: value } })
    .then(response => {
      if (response.data === undefined) {
        return response;
      } else {
        return response.data;
      }
    });
};
export const getservice = (backendservice, value) => {
  return app
    .service(backendservice)
    .get(value)
    .then(response => {
      if (response.data) {
        response = response.data;
      }
      return response;
    });
};
export const queryserviceobject = (service, queryobject) => {
  return app
    .service(service)
    .find({ query: queryobject })
    .then(response => {
      if (response.data) {
        response = response.data;
      }
      return response;
    });
};
export const createservice = (service, stuff, servicename) => {
  let Service =
    servicename || service.charAt(0).toUpperCase() + service.substr(1);
    console.log('Time Response', stuff)
  return app
    .service(service)
    .create(stuff)
    .then(response => {
      console.log('Time Response', response)
      if (response.data) {
        response = response.data;
      }
      return response;
    })
    .then(res => {
      if (servicename !== 'none') {
        feedbackHandler('Success', Service + ' Creation Success');
      }
      store.dispatch(updateField(service, res));

      return res;
    })
    .catch(err => {
      console.log('oops', err);
      feedbackHandler('Error', err.message);
    });
};
export const grabservice = service => {
  return app
    .service(service)
    .find()
    .then(response => {
      if (response.data === undefined) {
        return response;
      } else {
        return response.data;
      }
    });
};
export const grabserviceredux = (service, reducer) => {
  return app
    .service(service)
    .find()
    .then(response => {
      if(service === "customers"){
        console.log("customers found", response)
      }
      response = response.data ? response.data : response;
      let type = service + ' - ' + reducer;
      store.dispatch(datapop(response, type));
      return response;
    });
};
//    updateservice(service, object, id);
export const updateservice = (service, object, id, servicename) => {
  let Service =
    servicename || service.charAt(0).toUpperCase() + service.substr(1);
  return app
    .service(service)
    .update(id, object)
    .then(res => {
      console.log('update-field', res)
      store.dispatch(updateField(service, res));
      if (servicename !== 'none') {
        feedbackHandler('Success', Service + ' Updated Successfully');
      }
      return res;
    })
    .catch(err => {
      console.log('Update Error', err)
      feedbackHandler('Error On Update', err.message, 'cancel')});
};
export const queryserviceredux = (service, reducer, param, value) => {
  app
    .service(service)
    .find({ query: { [param]: value } })
    .then(response => {
      // export const datapop = (data, type) => {
      let type = service + ' - ' + reducer;
      if (response.data === undefined) {
        store.dispatch(datapop(response, type));
      } else {
        store.dispatch(datapop(response.data, type));
      }
    });
};
export const deleteservice = (service, id) => {
  return app
    .service(service)
    .remove(id)
    .then(response => {
      response = response.data ? response.data : response;
      feedbackHandler('Success', service.toUpperCase() + ' Deleted Successfully');
      store.dispatch(updateField(service, response, true));
      return response;
    });
};

export const feedbackHandler = (header, body) => {
  store.dispatch(
    newfeedback({
      color: header === 'Error' ? 'red' : 'green',
      icon: header === 'Error' ? 'warning circle' : 'check',
      header,
      body
    })
  );
};



// WEBPACK FOOTER //
// ./src/services/crudservice.js